<template>
    <v-container>
        <v-row class="rooms__header">
            <v-col cols="12 text-center">
                <span class="hotel-name">
                    {{ hotelName }}
                </span>
            </v-col>
        </v-row>
        <v-row class="rooms__page-title">
            <span class="rooms__title color-grey-onfly">
                Confira suas tarifas
            </span>
            <span class="rooms__subtitle color-grey-onfly">
                Revise, edite ou adicione novas tarifas do seu hotel.
            </span>
        </v-row>
        <room
            v-on:removeRoom="removeRoom"
            v-for="room in rooms"
            ref="rooms"
            :roomIndex="room.key"
            :key="room.key"
            :hotelRoom="hotelRooms !== null && hotelRooms[room.key - 1] !== undefined ? hotelRooms[room.key - 1] : null"
        />
        <div class="actions-bar">
            <v-container class="pb-0 px-0">
                <v-container class="actions-bar__content-container pb-6">
                    <v-row class="d-flex justify-end">
                        <v-col cols="12" md="4" class="btn-column">
                            <v-btn
                                depressed
                                color="blue-grey"
                                @click="goBack"
                                class="w-100 rounded-lg go-back-btn"
                            >
                                Voltar
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="btn-column">
                            <v-btn
                                depressed
                                color="primary"
                                @click="addRoom"
                                class="w-100 rounded-lg add-room-button"
                            >
                                Adicionar Quarto
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="btn-column">
                            <v-btn
                                depressed
                                color="success"
                                @click="validate"
                                class="w-100 rounded-lg"
                            >
                                Próximo
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-container>
        </div>
    </v-container>
</template>

<script>
import Room from "./Room.vue";
import ConfirmActionDialog from "../../Dialog/ConfirmActionDialog.vue";
import ResponseDialog from "../../Dialog/ResponseDialog.vue";

export default {
    name: "Rooms",
    components: {
        ResponseDialog,
        ConfirmActionDialog,
        Room
    },
    props: {
        hotelName: {
            type: String,
            default: null
        },
        hotelRooms: {
            type: Array,
            default: null
        },
    },
    data: () => ({
        valid: false,
        rooms: [{
            key: 1
        }],
    }),
    methods: {
        getData() {
            return this.$refs.rooms.map(room => {
                return room.getData();
            });
        },
        setData() {
            for(let i = 1; i < this.hotelRooms.length; i++){
                this.addRoom();
            }
        },
        addRoom() {
            let lastKey = this.rooms[this.rooms.length - 1].key;
            this.rooms.push({
                key: lastKey + 1
            })
        },
        removeRoom(key) {
            let indexOf = this.rooms.findIndex(room => {
                return room.key === key;
            });
            this.rooms.splice(indexOf, 1);
            this.hotelRooms.splice(indexOf, 1);
        },
        validate() {
            let valid = true;
            this.$refs.rooms.forEach(room => {
                room.validate();
                if (!room.$data.valid) {
                    valid = false;
                }
            });
            this.valid = valid;
            if (valid) {
                this.goNext();
            }
        },
        goNext () {
            this.$emit('next');
        },
        reloadPage () {
            window.location.reload();
            this.$forceUpdate();
        },
        goBack () {
            this.$emit('go-back')
        }
    },
    created() {
        if(this.hotelRooms !== null) {
            this.setData();
        }
    }
}
</script>

<style lang="scss" scoped>
.rooms__header {
    .hotel-name {
        font-size: 1.5rem;
        font-weight: 600;
        color: #064574;
    }
}

.rooms__page-title {
    display: flex;
    flex-direction: column;
    padding-left: 1rem;
    margin-bottom: 1rem;
    margin-top: 3rem;
}

.rooms__title {
    font-size: 1.125rem;
    font-weight: 600;
}

.rooms__subtitle {
    font-size: 0.875rem;
}

.go-back-btn {
    color: white !important;
}

.actions-bar {
    max-width: 1440px;
    margin: 0 auto;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 6px 12px 0 6px;
}

.actions-bar__content-container {
    padding: 1.5rem 1rem 0.5rem 1rem;
    background: white;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
}

@media (max-width: 960px) {
    .actions-bar {
        .btn-column {
            padding-top: 0;
            padding-bottom: 0;
            .add-room-button {
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
            }
        }
    }
}
</style>
